import http from '@/api/common'

export default {
  lookup(data, config) {
    return http.post('lookup/ByKey', data, config)
  },
  lookups(keys, config) {
    return http.post('lookup/ByKeys', keys, config)
  },
  lookupsZeus(key) {
    return http.get(`app/GetLookupValues?key=${key}`)
  },
  lookupsByGroup({ className, group }) {
    return http.get(`lookup/ByGroup?className=${className}&group=${group}`)
  },
  serverProfiles() {
    return http.get('device/GetServerProfiles')
  },
  scanTypes() {
    return http.get('lookup/GetScanTypes')
  },
  upsertScanType(data) {
    return http.post('lookup/UpsertScanType', data)
  },
  activationCards() {
    return http.get('lookup/GetActivationCards')
  },
  releaseTracks() {
    return http.get('lookup/GetReleaseTracks')
  },
  hardwares() {
    return http.get('lookup/GetHardwares')
  },
  upsertActivationCard(data) {
    return http.post('lookup/UpsertActivationCard', data)
  },
  upsertLookup(data) {
    return http.post('lookup/Upsert', data)
  },
  upsertLookupZeus(data) {
    return http.post('app/SaveZeusLookup', data)
  },
  upsertProduct(data) {
    return http.post('Business/UpsertProduct', data)
  },
  getTimeZones() {
    return http.get('lookup/TimeZones')
  },
  getDistributors() {
    return http.get('lookup/Distributors')
  },
  getSalesReps() {
    return http.get('lookup/SalesReps')
  },
  getVehicleManufacturers() {
    return http.get('lookup/VehicleManufacturers')
  },
  getInsuranceCompanies() {
    return http.get('lookup/InsuranceCompanies')
  },
  getProducts() {
    return http.get('lookup/Products')
  },
  getStates(id) {
    return http.get(`lookup/StateProvince?id=${id}`)
  },
  getCountries() {
    return http.get('lookup/Countries')
  },
  getLanguages() {
    return http.get('lookup/Languages')
  },
  savePreCannedMessages(data, config) {
    return http.post('lookup/SavePrecannedMessages', data, config)
  },
  getVehicleMakes(year) {
    return http.get(`lookup/VehicleMakes/?year=${year}`)
  },
  getProductAdds() {
    return http.get('lookup/ProductAdds')
  },
  upsertProductAdd(data) {
    return http.post('Business/UpsertProductAdd', data)
  },
  getMakes(showAll) {
    return http.get(`lookup/GetMakes?showAll=${showAll}`)
  },
  saveMakes(data, config) {
    return http.post('lookup/SaveMakes', data, config)
  },
  getProductMakes() {
    return http.get('lookup/ProductMakes')
  },
  getLaunchAccountList() {
    return http.get('smartlink/GetLaunchAccountList')
  },
  upsertProductMake(data) {
    return http.post('Business/UpsertProductMake', data)
  },
  getRagRatingList() {
    return http.get('lookup/RagRatingList')
  },
  getDeviceManufactureModels() {
    return http.get('app/GetDeviceManufactureAndModels')
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/lookup.js